import { render, staticRenderFns } from "./Notarios.vue?vue&type=template&id=1dd6d69a&scoped=true"
import script from "./Notarios.vue?vue&type=script&lang=js"
export * from "./Notarios.vue?vue&type=script&lang=js"
import style0 from "./Notarios.vue?vue&type=style&index=0&id=1dd6d69a&prod&lang=scss"
import style1 from "./Notarios.vue?vue&type=style&index=1&id=1dd6d69a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd6d69a",
  null
  
)

export default component.exports